import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {MsalProvider} from '@azure/msal-react';
import {PublicClientApplication} from '@azure/msal-browser';
import {toast} from 'react-toastify';
import App from '@app/App';
import store from '@store/store';
import './index.scss';
import './admin-lte-override.scss';
import './i18n';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';

toast.configure({
  autoClose: 3000,
  draggable: false,
  position: 'top-right',
  hideProgressBar: false,
  newestOnTop: true,
  closeOnClick: true,
  rtl: false,
  pauseOnVisibilityChange: true,
  pauseOnHover: true,
});

// MSAL configuration
const configuration = {
  auth: {
    clientId: 'ae717117-b5d3-4739-9214-d3bdaba7320c',
    // authority:
    //   'https://login.microsoftonline.com/2defb6d4-9a00-4026-a16c-cbe2a9a0134b/',
    authority:
      'https://jadsau.b2clogin.com/jadsau.onmicrosoft.com/B2C_1_signupsignin1',
    knownAuthorities: ['jadsau.b2clogin.com'],
    // redirectUri: 'http://localhost:3000/login',
    // logoutRedirectUri: 'http://localhost:3000/login',
    // redirectUri: 'https://localhost:3003/login',
    // postLogoutRedirectUri: 'http://localhost:3003/login',
    postLogoutRedirectUri: 'https://cceportaltest.kapsarc.org/login',
    navigateToLoginRequestUrl: true,
  },
};

const pca = new PublicClientApplication(configuration);

ReactDOM.render(
  <MsalProvider instance={pca}>
    <Provider store={store}>
      <App />
    </Provider>
  </MsalProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
